import appConfigs from "@/configs/common/appConfig.js"

function getPageTitle(page_name=null) {
    return page_name ? `${page_name} - ${appConfigs.HOMEPAGE_TITLE}` : appConfigs.HOMEPAGE_TITLE;
}

const titleUtility = {
    getPageTitle,
};
export default titleUtility;